export function LoadingScreen({ label = "Loading…" }: { label?: string }) {
  return (
    <main aria-live="polite" className="grid min-h-screen place-items-center">
      <p>{label}</p>
    </main>
  );
}
